// extracted by mini-css-extract-plugin
export default {"root":"MembershipFeatures-module-root","title":"MembershipFeatures-module-title","featured":"MembershipFeatures-module-featured","feature":"MembershipFeatures-module-feature"};